import React from "react";
import Header from "../../components/Header";
import {TranslatedAttribute} from "../../../../utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faFoursquare,
  faInstagram,
  faReadme,
  faTiktok,
  faTwitter,
  faYoutube
} from "@fortawesome/free-brands-svg-icons";
import {createModal} from "../../utils/modal";
import {faChevronUp, faCookieBite, faWifi} from "@fortawesome/free-solid-svg-icons";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

const Home = () => {
  const {t} = useTranslation();
  const {menuInfo, locale, googleCommentUrl, isGoogleComment, isShowFeedbackForm} = useSelector(state => state.app)
  const navigate = useNavigate();

  return (
    <div className={'h-full relative'}>
      <div className={'w-full absolute top-0 left-0'}>
        <Header />
      </div>

      <div className={' h-full flex flex-col justify-center items-center'}>
          
        <div className={'flex flex-col justify-between items-center'}>
          {
            menuInfo?.logo && (
              <div className={'mb-5'}>
                <img className={'rounded-xl'} src={menuInfo.logo} alt="Kardo QR Menü" width={125}
                    height={125}/>
              </div>
            )
          }

          <div className={'text-center'}>
            {
              TranslatedAttribute(locale, menuInfo, 'title') ?
                <h1
                  className={'text-[#555555] text-[30px] font-bold text-center my-3'}>{TranslatedAttribute(locale, menuInfo, 'title')}</h1> : <></>
            }
            <h3
              className={'text-[#555555] text-[15px] font-semibold text-center'}>{TranslatedAttribute(locale, menuInfo, 'sub_title') || ''}</h3>
          </div>

          {
            isGoogleComment === true ?
              (
                <a href={googleCommentUrl} rel={"noreferrer"} target={'_blank'}
                  className={'mt-5 image-bg-thirdy text-[#555] py-1 px-2 rounded-xl text-[14px]'}>
                  {t('menu.google_rating')}
                </a>
              ) : null
          }

          {
            isShowFeedbackForm === true ?
              (
                <div className={'mt-5 image-bg-thirdy text-[#555] py-1 px-2 rounded-xl text-[14px]'}
                    onClick={() => navigate('/feedback')}>
                  {t('menu.feedback_form')}
                </div>
              ) : null
          }

          {
            menuInfo.table && (
              <div className={'text-center mt-5'}>
                <h3 className={'text-[#555555] text-[15px] font-semibold text-center'}>{menuInfo.table}</h3>
              </div>
            )
          }
        </div>

        <div
          className={'bg-black w-full h-[180px] rounded-t-[30px] flex flex-col justify-between fixed bottom-0'}
          style={{}}>
          <div onClick={() => navigate('/menu')}
              className={'flex flex-col justify-center items-center cursor-pointer mt-4 mb-2'}>
            <FontAwesomeIcon icon={faReadme} color={'#fff'} size={'3x'}/>
            <span className={'text-white'}>{t('menu.go_menu')}</span>
          </div>

          <div onClick={() => createModal('home_info')}
              className={'bg-[#fff] w-full h-[80px] rounded-t-[30px] text-center pb-4'}>
            <FontAwesomeIcon icon={faChevronUp}/>

            <div className={'w-full mx-auto flex flex-row items-center justify-center'}>
              <div
                className={'h-[42px] w-[42px] rounded-[42px] image-bg-thirdy text-[#555] flex justify-center items-center mx-2'}>
                <FontAwesomeIcon icon={faCookieBite}/>
              </div>
              <div
                className={'h-[42px] w-[42px] rounded-[42px] image-bg-thirdy text-[#555] flex justify-center items-center mx-2'}>
                <FontAwesomeIcon icon={faWifi}/>
              </div>
              {
                menuInfo && menuInfo?.social_media ? (
                  Object.keys(menuInfo?.social_media).map((socialMedia, index) => {
                    if (Object.keys(menuInfo?.social_media).length >= 3 && index >= 3) {
                      return (<div key={socialMedia}></div>);
                    }
                    return (
                      <div key={socialMedia}>
                        {

                          menuInfo?.social_media[socialMedia] !== "" ?
                            <div
                              className={'h-[42px] w-[42px] rounded-[42px] image-bg-thirdy text-[#555] flex justify-center items-center mx-2'}>
                              {
                                socialMedia === "facebook" ?
                                  <FontAwesomeIcon icon={faFacebook}/>
                                  : socialMedia === "instagram" ?
                                    <FontAwesomeIcon icon={faInstagram}/>
                                    : socialMedia === "youtube" ?
                                      <FontAwesomeIcon icon={faYoutube}/>
                                      : socialMedia === "tiktok" ?
                                        <FontAwesomeIcon icon={faTiktok}/>
                                        : socialMedia === "twitter" ?
                                          <FontAwesomeIcon icon={faTwitter}/>
                                          : socialMedia === "foursquare" ?
                                            <FontAwesomeIcon icon={faFoursquare}/>
                                            : <></>
                              }

                            </div>
                            :
                            <></>
                        }
                      </div>
                    )
                  })
                ) : (
                  <></>
                )

              }
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Home;